import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import { AuthServices } from './auth.services';
import { Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { CommonServices} from '../../services/src/api';
import {AppServices, MsgPopupService} from '../../services';
import {Subscription} from 'rxjs/Subscription';

@Injectable()
export class ServiceResourceGuard implements CanActivate {
    private subscription: Subscription;
    constructor(private router: Router,
                private authService: AuthServices,
                private commonServices: CommonServices,
                private appServices: AppServices,
                private _msgPopupService: MsgPopupService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        const rsrcNo = JSON.parse(decodeURIComponent(route.params['option'])).svcNo;
        const curCmpnId = this.appServices.getCurCmpnId(route);

        return this.commonServices.getResourceAccessibleMap(curCmpnId, 'service', rsrcNo)
            .map(_data => {
                const IF_ACCESSIBLE = _data > 0;

                if (!IF_ACCESSIBLE) {
                    this._msgPopupService.msgEvent.emit({
                        'header_msg' : 'MK.01355',   // 접근 거부
                        'contents_msg' : 'MK.01356', // 접근 권한이 없습니다. 자세한 내용은 관리자에게 문의해주세요.
                        'close_btn_use_flag' : true
                    });
                }

                return IF_ACCESSIBLE;
            });

    }

}



// WEBPACK FOOTER //
// ./src/app/shared/authentications/src/service-rsrc.guard.ts